<template>
    <!--註冊用的電話驗證-->
    <div class="login">
        <navigation-bar Close/>
        <div @click="goVerify" class="help-info" v-if="codeType === 'Code'">
            <i class="el-icon-question i-info"/>
        </div>
        <div class="main-content">
            <div class="logo"><Logo/></div>
            <el-form class="textBox" ref="loginForm">
                <p class="text-center mb-2 blue">
                    {{codeType === 'Code'? '驗證碼已發送到您的手機' : '請詢問鄰近店家協助註冊'}}
                </p>
                <el-form-item class="mb-2">
                    <!--從Line過來的-->
                    <OpenEyes :value="tel" :disabled="true" class="input-round" v-if="lineStatus === 'verifyPhone' || lineStatus === 'lineVerifyPhone' || changType">
                        <template #front>
                            <div class="CountryCodeTW">{{countryName}}{{countryCode}}</div>
                        </template>
                    </OpenEyes>
                    <!--直接按問號進來-->
                    <OpenEyes ref="selectCountryCode" v-model="countryCodeData" :countryCodeData="countryCodeData"
                              :value="tel" :placeholder="'輸入手機'" :name="'tel'"
                              :type="'tel'" :maxlength='19' class="input-round" @onChange="valueChange" isCountryCode
                              v-else-if="codeType === 'noCode'"/>

                    <!--未註冊進來-->
                    <OpenEyes :value="tel" :disabled="true" class="input-round" v-else>
                        <template #front>
                            <div class="CountryCodeTW">{{countryName}}{{countryCode}}</div>
                        </template>
                    </OpenEyes>

                </el-form-item>

                <el-form-item>
                    <el-input type="tel" pattern="[0-9]*"
                              :placeholder="countryCode === '+886'? '請輸入驗證碼' : '請輸入服務人員提供的驗證碼' "
                              v-model="verificationCode" autocomplete="off" maxlength="4">
                        <el-button v-if="countryCode === '+886'" :disabled="isClick" slot="append" @click="sendSms"
                                   class="send-btn">
                            {{resendTitle}}
                        </el-button>
                    </el-input>
                </el-form-item>
            </el-form>

            <div class="forget" v-if="countryCode === '+886'" @click="callOutCode(tel)">
                收不到驗證碼？通話取得
            </div>

            <div class="btn_box">
                <el-button @click="goBack" round type="info" v-if="codeType !== 'noCode'">上一步</el-button>
                <el-button @click="checkSmsCode(tel, verificationCode)" :disabled="!verificationCode"
                           round type="warning">繼續</el-button>
            </div>

        </div>
        <toast/>
        <div class="brand" v-if="!isWeb">
            <span>LIFE LINK 串門子品牌服務系統</span>
        </div>
    </div>
</template>

<!-- 註冊用 電話驗證-->
<script>

    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import Logo from "@/components/Logo";
    import OpenEyes from "@/components/OpenEyes"
    export default {
        name: "RegisterPhoneVerify",
        components: {Toast,Logo,OpenEyes},
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        data() {
            return {
                dataToken: this.isWeb? (this.dataTokenWeb.dataToken ?? "") : (this.$route.query.dataToken ?? ""),
                dataObject: {},
                time: 61,
                isClick: false,
                resendTitle: '重新發送',
                verificationCode:'',
                // passwordForm: {
                //     verificationCode: '',
                // },
                error: {
                    phone: false,
                    verificationCode: false,
                    timer: 0
                },
                tel: this.isWeb ? this.dataTokenWeb.tel : this.$route.query.tel,
                countryCode: this.isWeb ? (this.dataTokenWeb.countryCode || "+886") : (this.$route.query.countryCode || "+886"),
                countryName: this.isWeb ? (this.dataTokenWeb.countryName || "TW") : (this.$route.query.countryName || "TW"),
                countryCodeData: {cnName: "台灣", code: "+886", enName: "TW", key: 1}, //國碼物件與Calculator模組回傳一致
                codeType: '', //Code-台灣未註冊 , noCodeForeign-外國未註冊 , noCode-直接按問號進來
                autoSend: '',
                type: 'register',
                // Line連動Users資料表用參數
                lineStatus: '',
                isLine: false,
                changType: false,
            }
        },
        created() {
            try {
                this.dataObject = this.$crypto.uriComponentToObject(this.dataToken)
            } catch (e) {
                this.dataObject = {}
            }
            this.codeType = this.isWeb ? this.dataTokenWeb.type : this.$route.query.type
            this.autoSend = this.isWeb ? this.dataTokenWeb.reg : this.$route.params.reg
            this.type = this.isWeb ? this.dataTokenWeb.reg : this.$route.params.reg //驗證碼類型

            if (this.countryCode === "+886") {
                this.sendSms()
            }
            this.lineStatus = this.$route.params.lineStatus || '';
            this.isLine = this.$route.params.isLine ||false;
        },
        mounted() {
        },
        watch:{
            verificationCode: function () {
                if (this.verificationCode.length>4) {
                    this.verificationCode=this.verificationCode.substr(0,4);
                }
            }
        },
        methods: {
            /** 開始倒數 */
            starCounting: function () {
                this.time = 61;
                this.isClick = true;
                this.timer = setInterval(this.countdown, 1000);
            },
            /** 倒數 */
            countdown: function () {
                this.time--;
                this.resendTitle = this.time
                if (this.time === 0) {
                    clearInterval(this.timer)
                    this.resendTitle = '重新發送'
                    this.isClick = false
                }
            },

            /** 發送驗證碼 */
            sendSms: function () {
                if (this.countryCode === "+886") {
                    this.$http.fetch`SendSmsVerify${{
                        'countryCode': this.countryCode,
                        'countryName': this.countryName,
                        'phone': this.tel,
                        'type': this.type
                    }}
                    ${json => {
                        if (json.status === true) {
                            this.starCounting();
                            //
                        } else {
                            //
                            this.$store.commit(mutationTypes.SHOW_TOAST, json.message);
                        }
                    }}`;
                }
            },
            /** 檢查驗證碼 */
            checkSmsCode: function (tel, verificationCode) {
                let self = this;
                this.$http.fetch`CheckVerifyCode${{
                    countryCode: self.countryCode,
                    countryName: self.countryName,
                    type: self.type,//'register',
                    phone:tel,
                    verifyCode:verificationCode,
                    lineStatus: self.lineStatus || '',
                    isLine: self.isLine || false,
                    botId: self.dataObject.botId || '',
                    lineChannelUserId: self.dataObject.lineUserId || '',
                    id: this.$route.params.userId || 0,
                }} ${json => {
                    if (json.status === true) {
                        this.codeType = ""
                        if ((self.dataObject.usedType === "webGetCoupon" && self.dataObject.id > 0)) {
                            this.$router.push({name: 'Registered', query: {tel: self.tel, countryCode: self.countryCode, countryName: self.countryName, dataToken: self.dataToken}});
                        } else if ((self.dataObject.usedType === "webGetCoupon" || self.dataObject.usedType === "webIndex" ||
                            self.dataObject.usedType === "reward-point" || self.dataObject.usedType === "member" ||
                            self.dataObject.usedType === "loyalty-card" || self.dataObject.usedType === "coupon" ||
                            self.dataObject.usedType === "oin-card") && (self.lineStatus === 'verifyPhone' || self.lineStatus === 'loginVerify') && self.isLine === true) {
                            let routerName = "Login"

                            sessionStorage.setItem("loginToken", this.$crypto.objectToURIComponent({
                                "usedType": routerName,
                                "tel": json.data.tel,
                                "countryCode": json.data.countryCode,
                                "countryName": json.data.countryName,
                                "password": json.data.password,
                            }))

                            this.$router.push({name: routerName, query: {dataToken: this.$crypto.objectToURIComponent(this.dataObject)}})
                        }
                        else {

                            if(!this.isWeb){
                                //APP、LINE綁定、商圈網頁版用
                                this.$router.push({name: 'Registered', query: {tel: self.tel, countryCode: self.countryCode, countryName: self.countryName, dataToken: self.dataToken,  lineStatus: this.lineStatus}});

                            }else {
                                //單店純網頁版用
                                const dataToken = {tel: self.tel, countryCode: self.countryCode, countryName: self.countryName, dataToken: self.dataToken, lineStatus: this.lineStatus}
                                this.$emit('push', dataToken , 'Registered');
                            }
                        }
                    } else {
                        this.$store.commit(mutationTypes.SHOW_TOAST, json.message);
                    }
                }}`;
            },
            /** 語音驗證 */
            callOutCode: function (tel) {
                let self = this;
                self.$http.fetch`SendPhoneVerify${{
                    countryCode: this.countryCode,
                    countryName: this.countryName,
                    type: 'register',
                    phone: tel,
                }} ${json =>{
                    this.$store.commit(mutationTypes.SHOW_TOAST, json.message);
                }}`;
            },

            // 轉店家發送驗證碼
            goVerify: function(){
                this.changType = !this.changType;
                this.codeType = this.changType ? 'noCode' : 'Code';
            },

            /** 回上一頁 */
            goBack: function () {
                this.codeType = ""
                if(!this.isWeb){
                    //APP、LINE綁定、商圈網頁版用
                    this.$router.go(-1)
                }else {
                    //單店純網頁版用
                    this.$emit('result', false);
                }

            },
            valueChange(countryCode, phone){
                this.tel = phone;
                this.countryCode = countryCode.code;
                this.countryName = countryCode.enName;
            },
        }
    }
</script>
<style lang="less" scoped src="../../less/login.less"/>

